import React, { FC } from 'react';
import { Dialog, Typography } from '@mui/material';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import { ModalContent } from 'pages/DeliveryPortal/DeliveryPortalPage.styles';
import * as Styles from './WarningUnprocessedDuplicatesModal.styles';

interface WarningUnprocessedDuplicatesModalProps {
  open: boolean;
  close: () => void;
}

export type ModalContentType = 'selectItem' | 'selectTray' | 'selectPart';

const WarningUnprocessedDuplicatesModal: FC<WarningUnprocessedDuplicatesModalProps> = ({ open, close }) => {
  const [language] = useLanguage();
  const handleClose = (): void => {
    close();
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={handleClose}>
      <ModalContent>
        <>
          <Styles.BoxStyled>
            <Typography variant="h5">
              <Styles.TitleContainer>
                <Styles.ErrorOutlineIconStyled />
                <Styles.ModalTitle>{language.DataUpload.warningUnprocessedDuplicatesModal.title}</Styles.ModalTitle>
              </Styles.TitleContainer>
              <Styles.TypographyStyled variant="subtitle1">
                {language.DataUpload.warningUnprocessedDuplicatesModal.subtitle}
              </Styles.TypographyStyled>
            </Typography>
          </Styles.BoxStyled>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => handleClose()}>
              {language.DataUpload.warningUnprocessedDuplicatesModal.return}
            </Button>
          </div>
        </>
      </ModalContent>
    </Dialog>
  );
};

export default WarningUnprocessedDuplicatesModal;
